<template>
  <div class="possibility-block">
    <div class="possibility-block__icon">
      <span class="possibility-block__icon-content"><slot /></span>
    </div>
    <div class="possibility-block__content">
      <h5 class="possibility-block__title">{{ title }}<br /><span class="possibility-block__subtitle">{{ subtitle }}</span></h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  }
};
</script>

<style scoped lang="scss">
.possibility-block {
  display: flex;
  align-items: center;
  width: 350px;
  background-color: #FFFFFF;
  border-radius: 32px;
  padding: 16px;
  margin: 0 auto;
  backdrop-filter: blur(24px);
  box-shadow: 0 14px 32px 0 #9199AE1C;

  @media (max-width: 1050px) {
    margin-bottom: 20px;
  }

  @media (min-width: 720px) and (max-width: 1050px) {
    flex: 0 0 45%;
  }

  &__icon {
    border: 9px solid #EB883B17;
    border-radius: 16px;
    margin-right: 24px;
    box-shadow: 0 7px 40px 0 #956B4914, 0px -26px 24.1px 0px #EB883B14 inset;
  }

  &__icon-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 46px;
    font-size: 26px;
  }

  &__content {
    flex: 1;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: #494E53;
  }

  &__subtitle {
    font-size: 16px;
    font-weight: 400;
    color: #494E53;
  }
}
</style>
